export default function (http) {
    return {


        /*************************产品管理接口开始***********************/

        queryByPage (data){
            return http.json({
                url: '/aftersale/order/item/query',
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/aftersale/order/item/get?id=${data.id}`,
                data
            })
        },
        queryAll (data){
            return http.json({
                url: '/aftersale/order/item/queryAll',
                data
            })
        },
        queryOrderItemAndFixItemByOrderId (data){
            return http.json({
                url: '/aftersale/order/item/queryOrderItemAndFixItemByOrderId',
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/aftersale/order/item/save`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/aftersale/order/item/delete`,
                data
            })
        },
        /** ***********************产品管理接口结束***********************/







    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/saleorderItem.js